const Footer = () => {
    return (
        <div className="footer">
            <a className="link" href="https://ticket.pt" target="_blank" rel="noreferrer">
                TICKET SERVIÇOS&reg;
            </a>
        </div>
    );
};

export default Footer;
